import React from 'react';
import styles from './Oneway.module.css';

const Oneway = () => {
    return (
        <div>
            Oneway component (Contacts)
        </div>
    )
}

export default Oneway;